const WorkflowStatusesIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 2H3.33333C2.59695 2 2 2.59695 2 3.33333V6C2 6.73638 2.59695 7.33333 3.33333 7.33333H6C6.73638 7.33333 7.33333 6.73638 7.33333 6V3.33333C7.33333 2.59695 6.73638 2 6 2Z"
        stroke="#0A0A0A"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66675 7.33301V9.99967C4.66675 10.3533 4.80722 10.6924 5.05727 10.9425C5.30732 11.1925 5.64646 11.333 6.00008 11.333H8.66675"
        stroke="#0A0A0A"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6667 8.66699H10.0001C9.2637 8.66699 8.66675 9.26395 8.66675 10.0003V12.667C8.66675 13.4034 9.2637 14.0003 10.0001 14.0003H12.6667C13.4031 14.0003 14.0001 13.4034 14.0001 12.667V10.0003C14.0001 9.26395 13.4031 8.66699 12.6667 8.66699Z"
        stroke="#0A0A0A"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default WorkflowStatusesIcon;
